import axios from '@/axios.js'
import moment from "moment";

export default {
  fetchUsages ({ commit }, { year , month}) {
    return new Promise((resolve, reject) => {
      axios.get(`/usage/findUsages/${month}/${year}`)
        .then((response) => {
          commit('SET_USAGES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchattendancepermonth2d ({ commit }, { year , month}) {
    return new Promise((resolve, reject) => {
      axios.get(`/employees/getattendancereport/${year}/${month}`)
        .then((response) => {
          commit('SET_ATTENDANCEPERMONTH2D', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchattendancepermonth ({ commit }, { year , month}) {
    return new Promise((resolve, reject) => {
      axios.get(`/employees/getattendancespermonth/data/${year}/${month}`)
        .then((response) => {
          commit('SET_ATTENDANCEPERMONTH', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  deletePresence ({ commit }, item) { 
    return new Promise((resolve, reject) => {
      axios.post('/employees/presence/delete', {item})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updatePresence ({ commit }, item) { 
    return new Promise((resolve, reject) => {
      console.log(item)
      axios.post('/employees/presence/update', {item})
        .then((response) => {
          var presence = response.data[0]
          commit('UPDATE_ATTENDANCES', presence )
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  }, 
  createPresence ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/employees/presence/create', {item})
        .then((response) => {
          commit('CREATE_ATTENDANCES', Object.assign(response.data, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createPresenceRange ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/employees/presence/createrange', {item})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchsummarypermonth0 ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      let year  = moment().format("YYYY")
      let month  = moment().format("MM")
      axios.get(`/employees/getattendancesummarymonth/${userId}/${year}/${month}`)
        .then((response) => {
          commit('SET_SUMMARY_PER_MONTH_0', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchsummarypermonth1 ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      let newDate = moment().add(-1, "month")
      let year  = moment(newDate).format("YYYY")
      let month  = moment(newDate).format("MM")
      axios.get(`/employees/getattendancesummarymonth/${userId}/${year}/${month}`)
        .then((response) => {
          commit('SET_SUMMARY_PER_MONTH_1', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchsummarypermonth2 ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      let newDate = moment().add(-2, "month")
      let year  = moment(newDate).format("YYYY")
      let month  = moment(newDate).format("MM")
      axios.get(`/employees/getattendancesummarymonth/${userId}/${year}/${month}`)
        .then((response) => {
          commit('SET_SUMMARY_PER_MONTH_2', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchDataAttendanceBasicListItems ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/employees/getattendancebasicdata/${userId}`)
        .then((response) => {
          commit('SET_ATTENDANCE_BASIC_DATA', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchDataAttendanceListItems ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/employees/getattendancelist/${userId}`)
        .then((response) => {
          commit('SET_ATTENDANCE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/employees/data')
        .then((response) => {
          commit('SET_EMPLOYEES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItem ({ commit }, item) { 
    return new Promise((resolve, reject) => {
      axios.post('/employees/update', {item})
        .then((response) => {
          var employee = response.data
          commit('UPDATE_EMPLOYEES', employee )
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/employees/create', {item})
        .then((response) => {
          commit('CREATE_EMPLOYEES', Object.assign(response.data, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // Pousse les employés actifs + PIN vers XYLO-ATTENDANCE (pointage).
  // Renvoie le rapport { created, updated, skipped, total, pushed }.
  pushToAttendance () {
    return new Promise((resolve, reject) => {
      axios.post('/employees/push-attendance')
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  }
}
